import React from 'react';
import '@/assets/styles/mental-health.scss';
import { useQuery } from '@/utils/hooks';
import { useTranslate } from '@/locale';
import no from '@/assets/images/depression_no.svg';
import mild from '@/assets/images/depression_mild.svg';
import moderate from '@/assets/images/depression_moderate.svg';
import severe from '@/assets/images/depression_severe.svg';
import moderatelySevere from '@/assets/images/depression_moderately_severe.svg';

const results = [
  {
    score: 20,
    illustration: severe,
    result: 'severeDepression',
    suggestion: 'severeDepressionSuggestion',
  },
  {
    score: 15,
    illustration: moderatelySevere,
    result: 'moderatelySevereDepression',
    suggestion: 'moderatelySevereDepressionSuggestion',
  },
  {
    score: 10,
    illustration: moderate,
    result: 'moderateDepression',
    suggestion: 'moderateDepressionSuggestion',
  },
  {
    score: 5,
    illustration: mild,
    result: 'mildDepression',
    suggestion: 'mildDepressionSuggestion',
  },
  {
    score: 0,
    illustration: no,
    result: 'minimalSignDepression',
    suggestion: 'minimalSignDepressionSuggestion',
  },
] as const;

const MentalHealth = () => {
  const { translate } = useTranslate();
  const q = useQuery();
  const score = Number(q.get('score') ?? 0);
  const { illustration, result, suggestion } =
    results.find(_ => score >= _.score) ?? results[0];

  return (
    <>
      <div className="ellipse">
        <svg
          viewBox="0 0 360 226"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="180" cy="-174" r="400" fill="#F8FAFF" />
        </svg>
      </div>
      <img src={illustration} alt="depresi_ringan" className="illustration" />
      <div className="texts">
        <div className="texts__score">
          <span className="texts__muted">{translate('quizScore')}</span>:{' '}
          <strong>{score}</strong>
        </div>
        <div className="texts__description">
          <div className="texts__muted">
            {score >= 5
              ? translate('youHaveATendencyOf')
              : translate('yourCondition')}
          </div>
          <div className="texts__highlight">{translate(result)}</div>
        </div>
        <p className="texts__suggest">{translate(suggestion)}</p>
      </div>
    </>
  );
};

export default MentalHealth;
